exports.components = {
  "component---src-app-js": () => import("./../../../src/App.js" /* webpackChunkName: "component---src-app-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

